import axios from 'axios';
import useContextService from 'hooks/useContextService';

const getSessionStorageDetails = () => {
  return JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
};

let instance = '';

const useAxios = () => {
  const { setStates } = useContextService();

  const setLoader = (hideLoader, loading) => {
    if (!hideLoader) setStates('loading', loading);
  };

  if (instance === '') {
    instance = axios.create({
      baseURL: `${process.env.REACT_API_ENDPOINT}`,
      responseType: 'json',
      headers: {
        'Content-type': 'application/json',
      },
    });

    instance.interceptors.request.use(
      (config) => {
        setLoader(config.hideLoader, true);
        const { token_type, access_token } = getSessionStorageDetails();
        config.headers.Authorization = `${token_type} ${access_token}`;
        if (config.hasDefaultURL) {
          config.url = `${config.baseURL}/${config.url}`;
        } else {
          config.url = `${config.baseURL}${config.url}`;
        }
        return config;
      },
      (error) => {
        setLoader(error.config.hideLoader, false);
        return Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      (response) => {
        setTimeout(() => {
          setLoader(response.config.hideLoader, false);
        }, 250);
        return response;
      },
      (error) => {
        setLoader(error.config.hideLoader, false);
        return Promise.reject(error);
      }
    );

    return instance;
  }

  return instance;
};

export default useAxios;
